import { render, staticRenderFns } from "./22-ADSR.vue?vue&type=template&id=540218e1&scoped=true"
import script from "./22-ADSR.vue?vue&type=script&lang=ts"
export * from "./22-ADSR.vue?vue&type=script&lang=ts"
import style0 from "./22-ADSR.vue?vue&type=style&index=0&id=540218e1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540218e1",
  null
  
)

export default component.exports